import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage, Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import noResults from '../../../assets/images/noResults.png';
import {AnalyticsInfoState} from '../reportElements/analyticsInfoState';
import {ReportSectionFrame} from '../reportElements/reportSection/reportSectionFrame';
import {LIVE_DASHBOARD_REDUCED_GAP_BREAKPOINT_VIEWPORT_WIDTH} from './constants';

/*
 * Styles.
 */

const StyledReportSectionFrame = styled(ReportSectionFrame)`
  height: calc(100% - 24px);
  display: grid;
  align-items: center;
  justify-items: center;

  @media screen and (max-width: ${LIVE_DASHBOARD_REDUCED_GAP_BREAKPOINT_VIEWPORT_WIDTH}px) {
    height: calc(100% - 12px);
  }
`;

/*
 * Component.
 */

export const LiveDashboardNoInboxesMessage: FC = () => {
  const localize = useLocalize();
  const title = localize(
    defineMessage({
      id: 'live-dashboard-no-inboxes-title',
      message: 'No inboxes selected yet',
    }),
  );

  return (
    <StyledReportSectionFrame>
      <AnalyticsInfoState
        imgWidth={92}
        imgHeight={67}
        imgPath={noResults}
        title={title}
        body={
          <Trans id="live-dashboard-no-inboxes-body">
            Select inboxes to access real-time workload and efficiency data.
          </Trans>
        }
      />
    </StyledReportSectionFrame>
  );
};
